import { Box } from '@bridebook/ui';
import { PropsWithChildren } from 'react';

import styles from './submit-button-desktop-wrapper.style';

const SubmitButtonDesktopWrapper: React.FC<PropsWithChildren> = ({ children }) => (
  <Box style={styles.wrapper}>{children}</Box>
);

export default SubmitButtonDesktopWrapper;
